import { getAriaWorkdays } from "../data/ariaWorkdays";

export const DEFAULT_TOTAL_WORKDAYS = 156;
export const MODEL_TOTAL_WORKDAYS = 124;
export const EDES_TOTAL_WORKDAYS = 120;

export const DEFAULT_CATALOG_ID = "default";
export const MODEL_CATALOG_ID = "hbfa_daily_checklist_prod";

export const DEFAULT_SCHEDULE_KEY = "default";
export const ARIA_169_SCHEDULE_KEY = "aria169";
export const EDES_120_SCHEDULE_KEY = "edes120";

export function isAriaProject(value) {
  return String(value || "").trim().toLowerCase().startsWith("aria");
}

export function isEdesCourtProject(value) {
  const normalized = String(value || "").trim().toLowerCase();
  return normalized === "edes" || normalized.startsWith("edes court");
}

export function normalizeChecklistProjectId(value) {
  if (!value) return "";
  const trimmed = String(value).trim();
  if (!trimmed) return "";
  if (isAriaProject(trimmed)) return "Aria";
  if (isEdesCourtProject(trimmed)) return "Edes Court";
  return trimmed;
}

export function normalizeChecklistBuildingNumber(value) {
  if (!value) return "";
  const match = String(value).match(/\d+/);
  return match ? match[0] : String(value).trim();
}

export function isModelBuilding(buildingNumber, projectId) {
  if (isEdesCourtProject(projectId)) return false;
  const key = normalizeChecklistBuildingNumber(buildingNumber);
  return key === "1" || key === "2";
}

export function isAriaFourStory(buildingNumber, projectId) {
  if (!isAriaProject(projectId)) return false;
  const key = normalizeChecklistBuildingNumber(buildingNumber);
  return key === "3" || key === "4";
}

export function getChecklistCatalogId({ projectId, buildingNumber }) {
  if (isEdesCourtProject(projectId)) return DEFAULT_CATALOG_ID;
  return isModelBuilding(buildingNumber, projectId) ? MODEL_CATALOG_ID : DEFAULT_CATALOG_ID;
}

export function getChecklistScheduleKey({ projectId, buildingNumber }) {
  if (isAriaFourStory(buildingNumber, projectId)) return ARIA_169_SCHEDULE_KEY;
  if (isEdesCourtProject(projectId)) return EDES_120_SCHEDULE_KEY;
  return DEFAULT_SCHEDULE_KEY;
}

export function resolveChecklistRows({
  projectId,
  buildingNumber,
  catalogRows = [],
  defaultRows = [],
  aria169Rows = [],
  edes120Rows = [],
}) {
  const scheduleKey = getChecklistScheduleKey({ projectId, buildingNumber });
  if (scheduleKey === ARIA_169_SCHEDULE_KEY) return aria169Rows;
  if (scheduleKey === EDES_120_SCHEDULE_KEY) return edes120Rows;
  if (Array.isArray(catalogRows) && catalogRows.length > 0) return catalogRows;
  return defaultRows;
}

export function getChecklistTotalWorkdays({ projectId, buildingNumber, uniqueness }) {
  const projectKey = normalizeChecklistProjectId(projectId);
  if (projectKey === "Aria") {
    return getAriaWorkdays(buildingNumber) ?? DEFAULT_TOTAL_WORKDAYS;
  }
  if (projectKey === "Edes Court") {
    return EDES_TOTAL_WORKDAYS;
  }
  if (isModelBuilding(buildingNumber, projectKey)) return MODEL_TOTAL_WORKDAYS;

  const normalizedUniqueness = String(uniqueness || "").trim().toUpperCase();
  const tags = normalizedUniqueness.split(",").map(value => value.trim()).filter(Boolean);
  if (tags.includes("MOD")) return MODEL_TOTAL_WORKDAYS;
  return DEFAULT_TOTAL_WORKDAYS;
}
